import * as React from 'react'
import styled, { css, keyframes } from "styled-components"

const opacity = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
	}
`

const Title = styled.div`
  width: 40%;
  min-height: 16px;
  background: rgb(245, 245, 245);
  border-radius: 100px;
`

const Description = styled.div`
  width: 60%;
  min-height: 16px;
  margin-top: 16px;
  background: rgb(245, 245, 245);
  border-radius: 100px;
`

const Metadata = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
`

const Avatar = styled.div`
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  border-radius: 50%;
  background: rgb(250, 250, 250);
  margin-top: 16px;
  float: left;
`

const MetadataContent = styled.div`
  display: flex;
  flex-direction: column;
`

const MetadataAuthorName = styled.div`
  min-width: 120px;
  min-height: 8px;
  margin-top: 19px;
  background: rgb(245, 245, 245);
  border-radius: 100px;
`

const MetadataAuthorDescription = styled.div`
  position: relative;
  min-width: 80px;
  min-height: 8px;
  margin-top: 12px;
  background: rgb(245, 245, 245);
  border-radius: 100px;
`

const Paragraph1 = styled.div`
  width: 80%;
  min-height: 8px;
  margin-top: 16px;
  background: rgb(245, 245, 245);
  border-radius: 100px;
`

const Paragraph2 = styled.div`
  width: 75%;
  min-height: 8px;
  margin-top: 16px;
  background: rgb(245, 245, 245);
  border-radius: 100px;
`

const Paragraph3 = styled.div`
  width: 160px;
  min-height: 8px;
  margin-top: 16px;
  background: rgb(245, 245, 245);
  border-radius: 100px;
`

const Container = styled.div<{ margins?: boolean }>`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  animation: ${opacity} 50ms ease-in-out;

  ${props => props.margins && css`
    ${Title}, ${Description}, ${Metadata}, ${Paragraph1}, ${Paragraph2}, ${Paragraph3} {
      margin-left: 10%;
    }
  `}

`

interface IProps {
  margins?: boolean
}

const ArticleSkeleton = (props: IProps) => {
  const { margins } = props

  return (
    <Container margins={margins}>
      <Title />
      <Description />
      <Metadata>
        <Avatar />

        <MetadataContent>
          <MetadataAuthorName />
          <MetadataAuthorDescription />
        </MetadataContent>
      </Metadata>

      <Paragraph1 />
      <Paragraph2 />
      <Paragraph3 />
    </Container>
  )
}

export default ArticleSkeleton